import { gql } from '@apollo/client';

// Hand-typed GraphQL operation for FreeCut Studio. There is no codegen for it —
// production introspection is disabled — so keep it in sync with the backend SDL:
//
//   myClipRenderData(id: ID!, input: JSON!): JSON

/**
 * The render data an export of the clip would hand the worker, without exporting (no quota, no
 * new clip version). `input` is the `renderLibraryClip` / `renderProjectClipV2` input.
 */
export const MY_CLIP_RENDER_DATA = gql`
  query MyClipRenderData($id: ID!, $input: JSON!) {
    myClipRenderData(id: $id, input: $input)
  }
`;

export interface MyClipRenderDataResult {
  myClipRenderData: Record<string, unknown> | null;
}

export interface MyClipRenderDataVariables {
  id: string;
  input: Record<string, unknown>;
}
